import { ComponentRef, Injectable, Optional, ViewContainerRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PlanerTilGodkendelseContainer } from './planer-til-godk/planer-til-godk.container';
import { D60Container } from './60d/60d.container';
import { AutorisationerContainer } from './autorisationer/autorisationer.container';
import { PlanerGodkendtContainer } from './planer-godkendt/planer-godkendt.container';
import { KALAContainer } from './ka-la/ka-la.container';
import { PopupsContainer } from './popups/popups.container';
import { SAKAContainer } from './sa-ka/sa-ka.container';
import { SamtalelogContainer } from './samtalelog/samtalelog.container';
import { SwitchOfficeContainer } from '../../core/switchoffice/switchoffice.container';
import { TimetrackModalContainer } from '../../timetrack/timetrack-modal/timetrack-modal.container';
import { ImpersonateContainer } from 'app/admin/impersonate/impersonate.container';
import { HolidayModalContainerComponent } from 'app/holiday/holiday-modal/holiday-modal.container';
import { InvoicesComponent } from 'app/invoices/invoices.component';
import { InterimInvoicingModalComponent } from 'app/invoices/interim-invoicing-modal/interim-invoicing-modal.component';
import { RegnskabsaarTilGodkendelseComponent } from './regnskabsaar-til-godkendelse/regnskabsaar-til-godkendelse.component';
import { OpdateringNoterService } from '../../core/opdatering-noter/opdatering-noter.service';
import { OpdateringNoterComponent } from '../../core/opdatering-noter/opdatering-noter.component';
import { tap } from 'rxjs/operators';
import { TilpasHandlingerTilGodkendelseComponent } from './tilpas-handlinger-til-godkendelse/tilpas-handlinger-til-godkendelse.component';
import { AuthDispatchers } from '../../auth/store/services';
import { Router } from '@angular/router';
import { V2NotifikationType } from '../store/models';
import { V2NotifikationModalComponent } from './v2-notifikation-modal/v2-notifikation-modal.component';
import { SagerTilGodkendelseComponent } from './sager-til-godkendelse/sager-til-godkendelse.component';
import { StatistikModalComponent } from '../../statistik/statistik-modal/statistik-modal.component';
import { UnicontaService } from '../../store/services/uniconta.service';
import { UnicontaSettingsComponent } from '../../settings/uniconta-settings/uniconta-settings.component';
import { StatistikService } from '../../statistik/statistik.service';
import { MsalService } from '@azure/msal-angular';
import { environment } from '../../../environments/environment';
import { EconomicSettingsComponent } from '../../settings/economic-settings/economic-settings.component';
import { EconomicService } from '../../store/services/economic.service';
import { MedarbejdereComponent } from 'app/medarbejdere/medarbejdere.component';

@Injectable({providedIn: 'root'})
export class MenuService {
    private viewContainerRef?: ViewContainerRef;
    private statistikModalRef?: ComponentRef<StatistikModalComponent>;
    isCloud = environment['authMode'] === 'cloud';

    constructor(
        private ngbModal: NgbModal,
        private opdateringNoterService: OpdateringNoterService,
        private authDispatch: AuthDispatchers,
        private router: Router,
        private unicontaService: UnicontaService,
        private statstikService: StatistikService,
        private economicService: EconomicService,
        @Optional() private msalService: MsalService
    ) {
    }

    async methodCall(method: string) {
        switch (method) {
            case 'logout':
                if (!this.isCloud) {
                    localStorage.removeItem('token');
                    this.authDispatch.logout();
                } else {
                    this.msalService.logoutRedirect();
                }
                break;
            case 'switchOffice':
                this.ngbModal.open(SwitchOfficeContainer, {size: 'sm'});
                break;
            case 'impersonate':
                this.ngbModal.open(ImpersonateContainer);
                break;
            case 'planerTilGodkendelse':
                this.ngbModal.open(PlanerTilGodkendelseContainer, {size: 'lg'});
                break;
            case 'planerGodkendt':
                this.ngbModal.open(PlanerGodkendtContainer, {size: 'lg'});
                break;
            case 'sagerGodkendtKA':
                this.ngbModal.open(KALAContainer, {size: 'lg'});
                break;
            case 'sagerGodkendtSA':
                this.ngbModal.open(SAKAContainer, {size: 'lg'});
                break;
            case 'sagerUafsluttede50':
                this.ngbModal.open(D60Container, {size: 'lg'});
                break;
            case 'autorisationer':
                this.ngbModal.open(AutorisationerContainer, {size: 'lg'});
                break;
            case 'popups':
                this.ngbModal.open(PopupsContainer, {size: 'lg'});
                break;
            case 'samtalelog':
                this.ngbModal.open(SamtalelogContainer, {size: 'lg'});
                break;
            case 'weeklyReports':
                this.ngbModal.open(TimetrackModalContainer, {size: 'xl'});
                break;
            case 'v2RegnskabsaarTilGodkendelse':
                this.ngbModal.open(RegnskabsaarTilGodkendelseComponent, {size: 'lg'});
                break;
            case 'v2KundeacceptGodkendt':
                const v2KundeacceptGodkendtModal = this.ngbModal.open(V2NotifikationModalComponent, {size: 'lg'});
                v2KundeacceptGodkendtModal.componentInstance.notifikationType = V2NotifikationType.KundeacceptGodkendt;
                break;
            case 'v2TilpasHandlingerTilGodkendelse':
                this.ngbModal.open(TilpasHandlingerTilGodkendelseComponent, {size: 'lg'});
                break;
            case 'v2TilpasHandlingerGodkendt':
                const v2TilpasHandlingerGodkendtModal = this.ngbModal.open(V2NotifikationModalComponent, {size: 'lg'});
                v2TilpasHandlingerGodkendtModal.componentInstance.notifikationType = V2NotifikationType.TilpasHandlingerGodkendt;
                break;
            case 'v2SagKonklusionTilGodkendelse':
                this.ngbModal.open(SagerTilGodkendelseComponent, {size: 'lg'});
                break;
            case 'v2SagKonklusionGodkendt':
                const v2SagKonklusionGodkendtModal = this.ngbModal.open(V2NotifikationModalComponent, {size: 'lg'});
                v2SagKonklusionGodkendtModal.componentInstance.notifikationType = V2NotifikationType.SagKonklusionGodkendt;
                break;
            case 'v2SagKonklusionGodkendtReviewpartner':
                const v2SagKonklusionGodkendtReviewpartnerModal = this.ngbModal.open(V2NotifikationModalComponent, {size: 'lg'});
                v2SagKonklusionGodkendtReviewpartnerModal.componentInstance.notifikationType = V2NotifikationType.SagKonklusionGodkendtReviewpartner;
                break;
            case 'v2SagKonklusionGodkendtSOP':
                const v2SagKonklusionGodkendtSOPModal = this.ngbModal.open(V2NotifikationModalComponent, {size: 'lg'});
                v2SagKonklusionGodkendtSOPModal.componentInstance.notifikationType = V2NotifikationType.SagKonklusionGodkendtSOP;
                break;
            case 'invoices':
                this.ngbModal.open(InvoicesComponent, {size: 'xl'});
                break;
            case 'interim-invoicing':
                this.ngbModal.open(InterimInvoicingModalComponent, {size: 'xl'});
                break;
            case 'holiday':
                this.ngbModal.open(HolidayModalContainerComponent, {size: 'lg'});
                break;
            case 'planlaegning':
                await this.router.navigate(['checklists', 'planlaegning']);
                break;
            case 'afslutning':
                await this.router.navigate(['checklists', 'afslutning']);
                break;
            case 'moms':
                await this.router.navigate(['checklists', 'moms']);
                break;
            case 'moms2':
                await this.router.navigate(['checklists', 'moms2']);
                break;
            case 'lonsum':
                await this.router.navigate(['checklists', 'lonsum']);
                break;
            case 'lon':
                await this.router.navigate(['checklists', 'lon']);
                break;
            case 'restskat-person':
                await this.router.navigate(['checklists', 'restskat-person']);
                break;
            case 'restskat-selskab':
                await this.router.navigate(['checklists', 'restskat-selskab']);
                break;
            case 'adhoc':
                await this.router.navigate(['checklists', 'adhoc']);
                break;
            case 'statistik':
                this.createStatistikModal();
                break;
            case 'clientActionsSettings':
                await this.router.navigate(['settings', 'client-actions-settings']);
                break;
            case 'opdateringNoter':
                this.opdateringNoterService.get90Days().pipe(
                    tap((noter) => {
                        const opdateringNoterModal = this.ngbModal
                            .open(OpdateringNoterComponent, {size: 'lg', backdrop: 'static', scrollable: true});
                        opdateringNoterModal.componentInstance.showFooter = false;
                        opdateringNoterModal.componentInstance.noter = noter;
                    })
                ).subscribe();
                break;
            case 'timeposterEconomic':
                this.economicService.timeposterToEconomic();
                break;
            case 'economic-settings':
                this.ngbModal.open(EconomicSettingsComponent, {size: 'lg'});
                break;
            case 'timeposterUniconta': this.unicontaService.timeposterToUniconta(); break;
            case 'uniconta-settings': this.ngbModal.open(UnicontaSettingsComponent, {size: 'lg'}); break;
            case 'medarbejdere': this.ngbModal.open(MedarbejdereComponent, {size: 'xl', windowClass: 'employee-modal', scrollable: true}); break;
            case 'uniconta-sync-clients': this.unicontaService.syncUnicontaClients(); break;
        }
    }

    setStatistikViewContainer(statistikModalHost: ViewContainerRef) {
        this.viewContainerRef = statistikModalHost;
    }

    createStatistikModal() {
        if (!this.statistikModalRef && this.viewContainerRef) {
            this.statistikModalRef = this.viewContainerRef.createComponent(StatistikModalComponent);
        }
        this.showStatistikModal();
    }

    destroyStatistikModal() {
        if (this.statistikModalRef) {
            this.statistikModalRef.destroy();
            this.statistikModalRef = undefined;
        }
    }

    showStatistikModal() {
        if (this.statistikModalRef) {
            this.statstikService.setVisible(true);
        }
    }
}
